export const restore = {
    rest: "Restore all parameters of this feature to the devicetype defaults.",
    default: "All parameters of this feature are in the devicetype defaults." 
}